var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sub-nav" }, [
    _c(
      "div",
      { staticClass: "sub-nav__inner" },
      _vm._l(_vm.menulist, function (item) {
        return _c(
          "div",
          {
            key: item.id,
            staticClass: "sub-nav__item",
            class: { "is-active": item.id == _vm.Index },
            on: {
              click: function ($event) {
                return _vm.Menupage(item.id)
              },
            },
          },
          [_vm._v(_vm._s(item.title))]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }